import { Link } from 'react-router-dom';
import { useI18n } from '@/i18n';
import type { LiveFamily } from '@/lib/liveFamilies';

interface LiveFamilyCardProps {
  family: LiveFamily;
  /** Table this card opens; absent while the catalog is still loading. */
  gameId?: string | null;
}

export function LiveFamilyCard({ family, gameId }: LiveFamilyCardProps) {
  const { t } = useI18n();
  const title = t(family.key);

  const body = (
    <article className={`live-family${family.active ? '' : ' is-soon'}`}>
      <div className="live-family__media">
        <img src={family.art} alt={title} className="live-family__art" />
        {family.active ? null : (
          <>
            <div className="live-family__scrim" aria-hidden="true" />
            <div className="live-family__copy">
              <h3 className="live-family__title display">{title}</h3>
              <span className="live-family__soon">{t('nav.comingSoon')}</span>
            </div>
          </>
        )}
      </div>
    </article>
  );

  if (!family.active || !gameId) {
    return (
      <div className="live-family-link is-disabled" aria-disabled="true">
        {body}
      </div>
    );
  }

  return (
    <Link to={`/library/${encodeURIComponent(gameId)}`} className="live-family-link">
      {body}
    </Link>
  );
}
